import { useEffect } from "react";
import { useLocation } from "wouter";
import { capturePageView } from "@/lib/analytics";

/**
 * Fire a `$pageview` analytics event whenever the wouter location changes.
 * Mounted once near the top of the React tree (inside the Router).
 *
 * We use the wouter location (not `window.location.pathname`) so SPA
 * navigations through `<Link>` and `setLocation()` are captured — those
 * never trigger a full page load.
 */
export function usePageViews(): void {
  const [location] = useLocation();
  useEffect(() => {
    // Compose with the artifact's base path so reports show the same
    // URL the user actually saw in their browser.
    const base = import.meta.env.BASE_URL.replace(/\/$/, "");
    capturePageView(`${base}${location}` || "/");
  }, [location]);
}
